import { render } from "./YearPicker.vue?vue&type=template&id=27045867"
import script from "./YearPicker.vue?vue&type=script&lang=ts"
export * from "./YearPicker.vue?vue&type=script&lang=ts"
script.render = render

export default script